import JoyListItemContent from '@mui/joy/ListItemContent'

const ListItemContent = ({ children, ...rest }) => {
  return <JoyListItemContent {...rest}>{children}</JoyListItemContent>
}

export default ListItemContent
